// extracted by mini-css-extract-plugin
export default {"chatLogContainer":"ChatLog_chatLogContainer__r0fI+"};